import React, { useState } from 'react';
import { FieldError } from 'react-hook-form';
import Input from '../../../../../Components/Form/components/Input';
// @ts-ignore
import styles from './Password.module.scss';

interface Props {
	value?: string;
	error?: FieldError;
	onChange?: React.FormEventHandler<HTMLInputElement>;
	placeholder?: string;
}

const Password: React.FC<Props> = ({ value, error, onChange, placeholder }) => {
	const [isHidden, setIsHidden] = useState(true);
	return (
		<div className={styles.wrapper}>
			<Input
				type={isHidden ? 'password' : 'text'}
				value={value}
				hasError={Boolean(error?.message)}
				onChange={onChange}
				placeholder={placeholder}
			/>
			<img
				src='/dist/patientV3/icons/eye-solid.svg'
				alt='eye'
				onClick={() => setIsHidden(prev => !prev)}
			/>
		</div>
	);
};

export default Password;
